// extracted by mini-css-extract-plugin
export default {"status":"Status_status__sQdT4","blocked":"Status_blocked__zP3X1"};